var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M23.847,11.468C23.655,11.163,19.071,4,12,4S.345,11.163.153,11.468a1,1,0,0,0,0,1.064C.345,12.837,4.929,20,12,20s11.655-7.163,11.847-7.468A1,1,0,0,0,23.847,11.468ZM12,16a4,4,0,1,1,4-4A4,4,0,0,1,12,16Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }